export default __webpack_public_path__ + "static/media/celular-edp.79a1ece4.png";